import { useState } from "react";
import api from "src/features/auth/axiosConfig";
import { notifyError } from "src/assets/toastService";
import { Order } from "src/shared/services/interfacev2";

export interface Pagination {
  page: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
}

export const useRunningOrders = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    pageSize: 12,
    totalRecords: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);

  const fetchOrders = async (pageNumber = 1, pageSize = 12, filters: { search?: string; status?: string; dateFrom?: string; dateTo?: string; sortBy?: string } = {}) => {
    try {
      setLoading(true);

      const params = new URLSearchParams({
        pageNumber: String(pageNumber),
        pageSize: String(pageSize),
        status: "pending",
      });

      if (filters.search) params.append("searchBy", filters.search);
      if (filters.dateFrom) params.append("dateFrom", filters.dateFrom);
      if (filters.dateTo) params.append("dateTo", filters.dateTo);
      if (filters.sortBy) params.append("sortBy", filters.sortBy);

      const res = await api.get(`/app/pos/v2/order?${params.toString()}`);

      const data: Order[] = res.data.result || [];

      setOrders(data);
      setPagination({
        page: res.data.pageNumber || pageNumber,
        pageSize: res.data.pageSize || pageSize,
        totalRecords: res.data.totalRecords || data.length,
        totalPages: Math.ceil((res.data.totalRecords || data.length) / pageSize),
      });
    } catch (err) {
      console.error(err);
      notifyError("Failed to fetch orders");
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => fetchOrders(pagination.page, pagination.pageSize);

  return { orders, pagination, loading, fetchOrders, setPagination, handleRefresh, totalRecords: pagination.totalRecords };
};
